import React from "react";
import PropTypes from "prop-types";

import { CrossButton } from "@sportal/cdk/crossButton/CrossButton";
import { useIntlTranslate } from "../../../hooks";
import { ModalDialog, useModalDialogContext } from "../Modal";
import { MODAL_WINDOW_TITLE_ID } from "@sportal/cdk/modal/Modal";

import "./CommonModalHeader.scss";

export const CommonModalHeader = ({ children }) => {
  const translate = useIntlTranslate();

  const { reject } = useModalDialogContext();

  return (
    <ModalDialog.Header>
      <h2 id={MODAL_WINDOW_TITLE_ID}>{children}</h2>
      <CrossButton
        className="modal__header__cross-button"
        size="small"
        weight="regular"
        onClick={reject}
        aria-label={translate("aria_close_dialog")}
      />
    </ModalDialog.Header>
  );
};

CommonModalHeader.propTypes = {
  children: PropTypes.node.isRequired,
};
